/* We Are Naturals · Interaktion
   Vanilla JS + GSAP/ScrollTrigger + Lenis. Seitenlogik nach body[data-page]. */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const P = window.WAN_PRODUCTS || [];
  const byId = Object.fromEntries(P.map(p => [p.id, p]));
  const euro = n => n.toFixed(2).replace('.', ',') + ' €';
  // image version: same stamp as main.js?v=…, so replaced photos never come from an old cache
  const IV = (m => (m ? '?v=' + m[1] : ''))(/[?&]v=(\d+)/.exec(document.currentScript?.src || ''));
  // uniform product cutouts: 800x800, same container height, centred with equal padding (tools/normalize_products.py)
  // Shopify theme: layout sets window.WAN_SHOP (asset base, live prices, variant ids, product urls)
  const SHOP = window.WAN_SHOP || null;
  if (SHOP) P.forEach(p => Object.assign(p, SHOP.products[p.id] || {}));
  // theme assets are flat: "products/norm/nad-400.webp" is uploaded as "products_norm_nad-400.webp"
  const img = path => (SHOP ? SHOP.asset + path.replace(/\//g, '_') + SHOP.v : `assets/img/${path}${IV}`);
  const productUrl = id => (SHOP ? byId[id]?.url || '/' : `produkt.html?p=${id}`);
  const prodImg = (id, w = 400) => img(`products/norm/${id}-${w}.webp`);
  // dose bundles: 2 doses of a product −15 %, 3 or more −20 % (per product line, also in the cart)
  const doseRate = q => (q >= 3 ? 0.2 : q === 2 ? 0.15 : 0);
  const round2 = x => Math.round((x + Number.EPSILON) * 100) / 100;
  // same maths as Shopify's checkout: the discount on the line is cut down to the cent, never rounded up
  // (worked in whole cents; the dose discount per unit, the sale on the order after dose discounts)
  const offCents = (amount, rate) => Math.floor(Math.round(amount * 100) * rate + 1e-9) / 100;
  const lineTotal = (price, q) => round2((price - offCents(price, doseRate(q))) * q);
  const doseUnit = (price, q) => round2(lineTotal(price, q) / q);
  const DEFAULT_DOSE = 1;
  const DEAL_SHORT = '2 Dosen −15 % · 3 Dosen −20 %';
  // order-wide sale (assets/js/sale.js), applied after the dose discounts on the whole order
  const SALE = (() => {
    const s = window.WAN_SALE;
    if (!s || !s.active || !(s.rate > 0)) return null;
    if (s.ends && Date.now() > new Date(s.ends + 'T23:59:59+02:00').getTime()) return null;
    return { name: s.name, rate: s.rate, pct: Math.round(s.rate * 100) };
  })();
  const salePrice = x => (SALE ? round2(x - offCents(x, SALE.rate)) : x);
  // shelf price: struck regular price + sale price while the sale runs
  const priceHTML = x => (SALE ? `<s class="was">${euro(x)}</s> ${euro(salePrice(x))}` : euro(x));
  if (SALE) $$('.promo__track').forEach(t => t.insertAdjacentHTML('afterbegin',
    `<span><b>${SALE.name}: −${SALE.pct} % auf alles</b>, zusätzlich zum Dosen-Rabatt</span><i class="dot"></i>`));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const mm = gsap.matchMedia();
  gsap.registerPlugin(ScrollTrigger);
  // phones: the address bar showing/hiding must not re-layout pinned scenes
  ScrollTrigger.config({ ignoreMobileResize: true });
  gsap.defaults({ ease: 'expo.out', duration: 1.2 });

  /* ---------- Smooth scroll ---------- */
  let lenis = null;
  if (!reduce && window.Lenis) {
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }
  // overlays: Lenis pauses the page, data-lenis-prevent lets the overlay itself scroll natively (touch, wheel, trackpad)
  const locks = new Set();
  const lockScroll = (who, on) => {
    on ? locks.add(who) : locks.delete(who);
    document.documentElement.classList.toggle('is-locked', locks.size > 0);
    locks.size ? lenis?.stop() : lenis?.start();
  };
  const scrollTo = target => {
    const el = typeof target === 'string' ? $(target) : target;
    if (!el) return;
    lenis ? lenis.scrollTo(el, { offset: -60, duration: 1.6 }) : el.scrollIntoView({ behavior: 'smooth' });
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2 || a.hasAttribute('data-add')) return;
    const t = $(a.getAttribute('href'));
    if (t) { e.preventDefault(); closeAll(); scrollTo(t); }
  });

  /* ---------- Text splitting ---------- */
  function splitWords(el) {
    const walk = node => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const parts = n.textContent.split(/(\s+)/);
          const frag = document.createDocumentFragment();
          parts.forEach(t => {
            if (!t) return;
            if (/^\s+$/.test(t)) frag.appendChild(document.createTextNode(' '));
            else { const s = document.createElement('span'); s.className = 'w'; s.style.display = 'inline-block'; s.textContent = t; frag.appendChild(s); }
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('pill')) walk(n);
      });
    };
    walk(el);
    return $$('.w', el);
  }
  // every word gets its own mask, no measuring, so wrapping stays natural on resize
  function prepLines(el) {
    return splitWords(el).map(w => {
      const m = document.createElement('span'); m.className = 'wm';
      w.replaceWith(m); m.appendChild(w); w.style.display = 'inline-block';
      return w;
    });
  }

  // scroll entrance with explicit end values (from() would read styles mid-transition)
  function enter(targets, from, to, trigger, start) {
    if (reduce) return;
    gsap.set(targets, from);
    ScrollTrigger.create({ trigger, start: start || 'top 85%', once: true, onEnter: () => gsap.to(targets, to) });
  }

  // pause endless tweens while their section is off-screen
  function whenVisible(el, tweens) {
    if (!el || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([e]) => tweens.forEach(t => (e.isIntersecting ? t.resume() : t.pause())), { rootMargin: '100px' }).observe(el);
  }

  /* ---------- Marquees (Tempo folgt der Scrollgeschwindigkeit) ---------- */
  const marquees = [];
  function marquee(track) {
    const base = +track.dataset.marquee || 50;
    const dir = track.hasAttribute('data-reverse') ? 1 : -1;
    const kids = [...track.children];
    let w = track.scrollWidth;
    while (track.scrollWidth < innerWidth * 2.2 && kids.length) kids.forEach(k => track.appendChild(k.cloneNode(true)));
    const all = [...track.children]; all.forEach(k => track.appendChild(k.cloneNode(true)));
    w = track.scrollWidth / 2;
    const m = { track, x: dir > 0 ? -w : 0, w, base, dir, boost: 0, hidden: false };
    marquees.push(m);
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { m.hidden = !e.isIntersecting; }).observe(track.parentElement);
  }
  function tickMarquees(dt) {
    const v = lenis ? Math.abs(lenis.velocity || 0) : 0;
    marquees.forEach(m => {
      if (m.hidden) return;
      m.boost += (Math.min(v, 60) * 4 - m.boost) * 0.08;
      m.x += m.dir * (m.base + m.boost) * dt;
      if (m.x <= -m.w) m.x += m.w;
      if (m.x >= 0) m.x -= m.w;
      m.track.style.transform = `translate3d(${m.x}px,0,0)`;
    });
  }

  /* ---------- Header ---------- */
  const hdr = $('#hdr');
  let lastY = 0;
  function onScrollHeader(y) {
    hdr.classList.toggle('is-solid', y > 30);
    const goingDown = y > lastY && y > 700;
    if (!$('#mega')?.classList.contains('is-open') && !document.body.classList.contains('menu-open')) hdr.classList.toggle('is-hidden', goingDown);
    lastY = y;
  }
  lenis ? lenis.on('scroll', e => onScrollHeader(e.scroll)) : addEventListener('scroll', () => onScrollHeader(scrollY), { passive: true });

  // mega menu
  const mega = $('#mega'), megaBtn = $('[data-mega]');
  if (mega) {
    $('#megaGrid').innerHTML = P.map(p => `<a class="mega__item" href="${productUrl(p.id)}" style="--t:${p.tint}">
      <img src="${prodImg(p.id)}" alt="" loading="lazy"><b>${p.name}</b><span>${priceHTML(p.price)}</span></a>`).join('');
    let hideT;
    const open = () => { clearTimeout(hideT); mega.hidden = false; requestAnimationFrame(() => mega.classList.add('is-open')); megaBtn.setAttribute('aria-expanded', 'true'); hdr.classList.add('is-solid');
      gsap.fromTo($$('.mega__item', mega), { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.035, duration: 0.9, overwrite: true }); };
    const close = () => { mega.classList.remove('is-open'); megaBtn.setAttribute('aria-expanded', 'false'); hideT = setTimeout(() => { mega.hidden = true; }, 700); };
    megaBtn.addEventListener('click', () => mega.classList.contains('is-open') ? close() : open());
    if (fine) {
      megaBtn.addEventListener('mouseenter', open);
      hdr.addEventListener('mouseleave', close);
      $$('.hdr__link:not([data-mega])').forEach(l => l.addEventListener('mouseenter', close));
    }
    mega.addEventListener('click', e => { if (e.target.closest('a')) close(); });
    window.closeMega = close;
  }
  // mobile menu
  const burger = $('#burger'), menu = $('#menu');
  $('#menuProducts').innerHTML = P.map(p => `<a href="${productUrl(p.id)}" style="--t:${p.tint}"><img src="${prodImg(p.id)}" alt="" loading="lazy">${p.name}</a>`).join('')
    + `<a class="menu__all" href="${SHOP ? '/collections/alle-produkte' : 'index.html#produkte'}">Alle Produkte ansehen <svg><use href="#i-arrow"/></svg></a>`;
  burger.addEventListener('click', () => {
    const on = burger.getAttribute('aria-expanded') !== 'true';
    burger.setAttribute('aria-expanded', on);
    document.body.classList.toggle('menu-open', on);
    if (on) { menu.hidden = false; requestAnimationFrame(() => menu.classList.add('is-open')); lockScroll('menu', true);
      gsap.fromTo($$('.menu__nav a, .menu__products a', menu), { y: 40, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.05, delay: 0.2 }); }
    else { menu.classList.remove('is-open'); lockScroll('menu', false); setTimeout(() => { if (!menu.classList.contains('is-open')) menu.hidden = true; }, 800); }
  });
  menu.addEventListener('click', e => { if (e.target.closest('a')) closeAll(); });
  function closeAll() {
    if (burger.getAttribute('aria-expanded') === 'true') burger.click();
    window.closeMega && mega && mega.classList.contains('is-open') && window.closeMega();
  }

  /* ---------- Cart ---------- */
  // Static preview: local cart with the dose maths below.
  // Shopify: the real cart (/cart.js). Every amount shown comes from Shopify, so drawer and checkout always match.
  const cartEl = $('#cart');
  let cart = [];
  // quantity taps: the number changes at once; requests run one after another and always use the line's
  // current key (Shopify gives a line a new key whenever its dose discount changes)
  const pending = {};
  const byHandle = Object.fromEntries(P.map(p => [p.handle, p]));
  const cents = n => n / 100;
  if (!SHOP) { try { cart = JSON.parse(localStorage.getItem('wan-cart') || '[]').filter(i => byId[i.id]); } catch (e) { cart = []; } }
  const save = () => { if (!SHOP) try { localStorage.setItem('wan-cart', JSON.stringify(cart)); } catch (e) {} };
  // one normalised shape for both: lines + totals
  function cartModel() {
    if (SHOP) {
      // only a real cart object counts (an error answer must never be shown as the cart)
      const c = Array.isArray(SHOP.cart?.items) ? SHOP.cart : { items: [], total_price: 0, items_subtotal_price: 0, cart_level_discount_applications: [] };
      const lines = c.items.map(i => {
        const p = byHandle[i.handle];
        return { key: i.key, vid: String(i.variant_id), id: p?.id, q: pending[i.variant_id] ?? i.quantity, busy: pending[i.variant_id] !== undefined, name: p?.name || i.product_title, type: p?.type || '', tint: p?.tint || '#E9DCCB',
          image: p ? prodImg(p.id) : (i.image || ''), full: cents(i.original_line_price), now: cents(i.final_line_price) };
      });
      const full = lines.reduce((t, l) => t + l.full, 0);
      const orderApps = c.cart_level_discount_applications || [];
      const saleOff = cents(orderApps.reduce((t, d) => t + d.total_allocated_amount, 0));
      return { lines, full, now: cents(c.items_subtotal_price), saleOff, saleName: orderApps.map(d => d.title).join(', '), total: cents(c.total_price) };
    }
    const lines = cart.map(i => { const p = byId[i.id];
      return { key: i.id, vid: i.id, id: i.id, q: i.q, name: p.name, type: p.type, tint: p.tint, image: prodImg(p.id), full: p.price * i.q, now: lineTotal(p.price, i.q) }; });
    const full = cart.reduce((t, i) => t + i.q * byId[i.id].price, 0);
    const now = round2(lines.reduce((t, l) => t + l.now, 0));
    // the sale is taken once, from the order after dose discounts (never per line, never twice)
    const saleOff = SALE ? offCents(now, SALE.rate) : 0;
    return { lines, full, now, saleOff, saleName: SALE ? `${SALE.name} −${SALE.pct} %` : '', total: round2(now - saleOff) };
  }
  function renderCart() {
    const m = cartModel(), L = m.lines;
    const n = L.reduce((t, l) => t + l.q, 0);
    const cnt = $('#cartCount');
    cnt.textContent = n; cnt.classList.toggle('is-on', n > 0);
    $('#cartN').textContent = n ? `(${n})` : '';
    cartEl.classList.toggle('is-empty', !n);
    const best = L.reduce((t, l) => Math.max(t, l.id ? l.q : 0), 0);
    const single = L.find(l => l.id && l.q === 1);
    $('#cartBar').style.width = Math.min(best / 3, 1) * 100 + '%';
    $('#cartDeal').textContent = single
      ? `Tipp: Mit einer zweiten Dose ${single.name} sparst du 15 %, mit drei 20 %.`
      : best >= 3 ? 'Super, du sparst 20 % mit 3 Dosen.' : best === 2 ? 'Super, du sparst 15 %. Mit 3 Dosen sind es 20 %.' : '2 Dosen −15 %, 3 Dosen −20 %';
    const doseOff = round2(m.full - m.now);
    $('#cartSaveRow').classList.toggle('is-on', doseOff > 0.004);
    $('#cartSave').textContent = doseOff > 0.004 ? '−' + euro(doseOff) : '';
    $('#cartSaleRow').classList.toggle('is-on', m.saleOff > 0);
    $('#cartSaleName').textContent = m.saleName;
    $('#cartSale').textContent = m.saleOff > 0 ? '−' + euro(m.saleOff) : '';
    $('#cartSub').textContent = euro(m.full);
    $('#cartTotal').textContent = euro(m.total);
    $('#cartList').innerHTML = L.map(l => `<li class="ci${l.busy ? ' is-busy' : ''}" data-vid="${l.vid}">
      <div class="ci__img" style="--t:${l.tint}">${l.image ? `<img src="${l.image}" alt="">` : ''}</div>
      <div><b>${l.name}</b><small>${l.type}</small>
        <div class="qty"><button data-q="-1" aria-label="Weniger"><svg><use href="#i-minus"/></svg></button><span>${l.q}</span><button data-q="1" aria-label="Mehr"><svg><use href="#i-plus"/></svg></button></div></div>
      <p class="ci__price">${l.full - l.now > 0.004 ? `<s>${euro(l.full)}</s>` : ''}${euro(l.now)}</p></li>`).join('');
    save();
  }
  // Shopify AJAX cart
  const shopCart = (url, body) => fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(r => r.json()).then(j => { if (!j || !Array.isArray(j.items)) throw j || {}; return j; });
  const refreshCart = () => shopCart(SHOP.routes.cart + '.js').then(c => { SHOP.cart = c; renderCart(); return c; });
  let busy = Promise.resolve();
  const queue = fn => (busy = busy.then(fn, fn).catch(() => {}));
  function openCart() { cartEl.classList.add('is-open'); cartEl.setAttribute('aria-hidden', 'false'); lockScroll('cart', true); }
  function closeCart() { if (!cartEl.classList.contains('is-open')) return; cartEl.classList.remove('is-open'); cartEl.setAttribute('aria-hidden', 'true'); lockScroll('cart', false); }
  $('#cartBtn').addEventListener('click', openCart);
  cartEl.addEventListener('click', e => {
    if (e.target.closest('[data-close]')) closeCart();
    if (e.target.closest('[data-checkout]')) { location.href = SHOP ? SHOP.routes.checkout : '#'; return; }
    const b = e.target.closest('[data-q]');
    if (!b) return;
    const li = b.closest('.ci'), vid = li.dataset.vid;
    if (SHOP) {
      const line = SHOP.cart?.items?.find(i => String(i.variant_id) === vid);
      if (!line) { refreshCart(); return; }
      const want = Math.max(0, (pending[vid] ?? line.quantity) + +b.dataset.q);
      pending[vid] = want;
      li.querySelector('.qty span').textContent = want;
      li.classList.add('is-busy');
      queue(async () => {
        const target = pending[vid];
        if (target === undefined) return;
        const cur = SHOP.cart?.items?.find(i => String(i.variant_id) === vid);
        if (!cur || cur.quantity === target) { delete pending[vid]; return renderCart(); }
        try { SHOP.cart = await shopCart(SHOP.routes.change, { id: cur.key, quantity: target }); }
        catch (err) { delete pending[vid]; return refreshCart(); }
        if (pending[vid] === target) delete pending[vid];
        renderCart();
      });
      return;
    }
    const it = cart.find(i => i.id === vid);
    it.q += +b.dataset.q; if (it.q < 1) cart = cart.filter(i => i !== it);
    renderCart();
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeAll(); } });
  function addToCart(id, fromEl, qty = 1) {
    if (SHOP) {
      const p = byId[id];
      if (!p?.variant) return;
      queue(() => shopCart(SHOP.routes.add, { items: [{ id: p.variant, quantity: qty }] }).then(refreshCart)
        .catch(err => { $('#cartDeal').textContent = err?.description || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.'; openCart(); }));
    } else {
      const it = cart.find(i => i.id === id);
      it ? (it.q += qty) : cart.push({ id, q: qty });
      renderCart();
    }
    const cnt = $('#cartCount'); cnt.classList.remove('bump'); void cnt.offsetWidth; cnt.classList.add('bump');
    // flight to the bag
    const src = fromEl?.closest?.('.card')?.querySelector('.card__img') || fromEl;
    if (src && !reduce) {
      const r = src.getBoundingClientRect(), t = $('#cartBtn').getBoundingClientRect();
      const img = Object.assign(document.createElement('img'), { src: prodImg(id), className: 'fly', alt: '' });
      document.body.appendChild(img);
      hdr.classList.remove('is-hidden');
      gsap.set(img, { x: r.left + r.width / 2 - 35, y: r.top + r.height / 2 - 50, scale: 1.4 });
      gsap.timeline({ onComplete: () => img.remove() })
        .to(img, { x: t.left + t.width / 2 - 35, duration: 0.9, ease: 'power2.inOut' }, 0)
        .to(img, { y: t.top + t.height / 2 - 50, duration: 0.9, ease: 'back.in(1.4)' }, 0)
        .to(img, { scale: 0.2, rotation: 25, opacity: 0.4, duration: 0.9, ease: 'power2.in' }, 0);
    }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    addToCart(b.dataset.add, b);
    if (b.classList.contains('card__add')) {
      b.classList.add('is-done'); b.innerHTML = '<svg><use href="#i-check"/></svg>';
      setTimeout(() => { b.classList.remove('is-done'); b.innerHTML = '<svg><use href="#i-plus"/></svg>'; }, 1600);
    }
  });
  renderCart();
  // back/forward cache and other tabs: always show the current Shopify cart
  if (SHOP) { refreshCart(); addEventListener('pageshow', e => e.persisted && refreshCart()); }

  /* ---------- Product sheet (phones) ---------- */
  const sheet = $('#psheet');
  let sheetFrom = null;
  function openSheet(id, fromEl) {
    const p = byId[id]; if (!p || !sheet) return;
    sheetFrom = fromEl || null;
    $('#psheetImg').style.setProperty('--t', p.tint);
    Object.assign($('#psheetImg img'), { src: prodImg(id), alt: p.full });
    $('#psheetType').textContent = p.type;
    $('#psheetName').textContent = p.name;
    $('#psheetFact').innerHTML = `<b>${p.fact[0]}</b> ${p.fact[1]}`;
    $('#psheetPrice').innerHTML = priceHTML(p.price);
    $('#psheetAdd').dataset.add = id;
    $('#psheetMore').href = productUrl(id);
    sheet.style.removeProperty('--drag');
    sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false');
    lockScroll('sheet', true);
    setTimeout(() => $('.psheet__close', sheet).focus({ preventScroll: true }), 300);
  }
  function closeSheet(clearSpots = true) {
    if (!sheet?.classList.contains('is-open')) return;
    sheet.classList.remove('is-open', 'is-dragging'); sheet.setAttribute('aria-hidden', 'true');
    sheet.style.removeProperty('--drag');
    lockScroll('sheet', false);
    if (clearSpots) $$('.spot.is-open').forEach(s => { s.classList.remove('is-open'); s.querySelector('button').setAttribute('aria-expanded', 'false'); });
    sheetFrom?.querySelector('button')?.focus({ preventScroll: true });
    sheetFrom = null;
  }
  if (sheet) {
    sheet.addEventListener('click', e => { if (e.target.closest('[data-sheet-close]')) closeSheet(); });
    // add to cart, then let the sheet go
    $('#psheetAdd').addEventListener('click', () => setTimeout(closeSheet, 350));
    // swipe down to close
    const panel = $('.psheet__panel', sheet);
    let y0 = null, dy = 0;
    panel.addEventListener('touchstart', e => { y0 = e.touches[0].clientY; dy = 0; sheet.classList.add('is-dragging'); }, { passive: true });
    panel.addEventListener('touchmove', e => { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.setProperty('--drag', dy + 'px'); }, { passive: true });
    panel.addEventListener('touchend', () => { sheet.classList.remove('is-dragging'); y0 = null; dy > 80 ? closeSheet() : sheet.style.removeProperty('--drag'); });
    addEventListener('keydown', e => { if (e.key === 'Escape') closeSheet(); });
    matchMedia('(max-width: 760px)').addEventListener?.('change', () => closeSheet());
  }

  /* ---------- Product card + rail (shared by home and product page) ---------- */
  function cardHTML(p) {
    return `<li class="card" data-need="${p.need}" style="--t:${p.tint}">
      <a class="card__stage" href="${productUrl(p.id)}" aria-label="${p.full}">
        <div class="card__fact"><b>${p.fact[0]}</b><span>${p.fact[1]}</span></div>
        <span class="card__type">${p.type}</span>
        <i class="card__plinth"></i>
        <img class="card__img" src="${prodImg(p.id)}" srcset="${prodImg(p.id)} 400w, ${prodImg(p.id, 800)} 800w" sizes="(max-width: 760px) 80vw, 340px" alt="" loading="lazy" decoding="async" draggable="false">
        <span class="card__deal">${DEAL_SHORT}</span>
      </a>
      <div class="card__meta">
        <h3 class="card__name"><a href="${productUrl(p.id)}">${p.name}</a></h3>
        <p class="card__full">${p.full}</p>
        <p class="card__price">${priceHTML(p.price)}</p>
        <button class="card__add" data-add="${p.id}" aria-label="${p.name} in den Warenkorb"><svg><use href="#i-plus"/></svg></button>
      </div></li>`;
  }
  // rail: drag with inertia on mouse, native momentum scroll + snap on touch
  function initRail(rail, list, ui) {
    const track = rail.querySelector('.rail__track');
    const api = { track, measure: () => {}, reset: () => {} };
    track.innerHTML = list.map(cardHTML).join('');
    // touch screens scroll the rail natively (momentum + snap); mouse users drag with inertia
    const native = !fine;
    let x = 0, target = 0, min = 0, dragging = false, startX = 0, startT = 0, vel = 0, lastX = 0, moved = 0;
    const measure = () => { min = Math.min(0, innerWidth - track.scrollWidth); target = Math.max(min, Math.min(0, target)); };
    const bar = ui.bar;
    const step = () => (track.children[0]?.offsetWidth || 300) + 20;
    const setBar = (p, frac) => { bar.style.width = frac * 100 + '%'; bar.style.transform = `translateX(${p * (100 / frac - 100)}%)`; };
    if (native) {
      rail.classList.add('is-native');
      const upd = () => { const max = rail.scrollWidth - rail.clientWidth; setBar(max > 0 ? rail.scrollLeft / max : 0, Math.min(1, rail.clientWidth / rail.scrollWidth)); };
      rail.addEventListener('scroll', upd, { passive: true });
      addEventListener('resize', upd); upd();
      ui.next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      ui.prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      api.reset = () => { rail.scrollTo({ left: 0 }); requestAnimationFrame(upd); };
    } else {
      rail.addEventListener('pointerdown', e => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; moved = 0; startX = lastX = e.clientX; startT = target; vel = 0;
        rail.classList.add('is-drag');
      });
      addEventListener('pointermove', e => {
        if (!dragging) return;
        const dx = e.clientX - startX; moved = Math.max(moved, Math.abs(dx));
        vel = e.clientX - lastX; lastX = e.clientX;
        let t = startT + dx;
        if (t > 0) t *= 0.35; if (t < min) t = min + (t - min) * 0.35;
        target = t;
      });
      addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false; rail.classList.remove('is-drag');
        target = Math.max(min, Math.min(0, target + vel * 14));
      });
      rail.addEventListener('click', e => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      ui.next.addEventListener('click', () => { target = Math.max(min, target - step() * 2); });
      ui.prev.addEventListener('click', () => { target = Math.min(0, target + step() * 2); });
      rail.addEventListener('wheel', e => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); target = Math.max(min, Math.min(0, target - e.deltaX)); }
      }, { passive: false });
      gsap.ticker.add(() => {
        if (!dragging && Math.abs(target - x) < 0.05) return;
        x += (target - x) * 0.1;
        track.style.transform = `translate3d(${x}px,0,0)`;
        setBar(min ? x / min : 0, Math.min(1, innerWidth / track.scrollWidth));
      });
      addEventListener('resize', measure);
      measure();
      api.reset = () => { target = 0; x = 0; track.style.transform = 'translate3d(0,0,0)'; };
    }

    api.measure = typeof measure === 'function' ? measure : api.measure;
    // custom cursor
    const cur = $('#cursor');
    if (fine && !reduce && cur) {
      rail.addEventListener('mouseenter', () => cur.classList.add('is-on'));
      rail.addEventListener('mouseleave', () => cur.classList.remove('is-on'));
      rail.addEventListener('mouseover', e => cur.classList.toggle('is-on', !e.target.closest('.card__add, .card__name a')));
    }
    if (!reduce) enter($$('.card', track), { x: 160, opacity: 0 }, { x: 0, opacity: 1, stagger: 0.07, duration: 1.5 }, rail, 'top 85%');
    return api;
  }
  // Shopify collection and search pages: our cards for known products (placeholders from snippets/wan-card.liquid)
  $$('[data-wan]').forEach(li => { const p = byId[li.dataset.wan]; if (p) li.outerHTML = cardHTML(p); });
  if (!reduce && $('.pgrid .card')) enter($$('.pgrid .card'), { y: 40, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.06, duration: 1.1 }, $('.pgrid'), 'top 90%');
  if (fine && !reduce && $('#cursor')) {
    const cur = $('#cursor');
    const cx = gsap.quickTo(cur, 'x', { duration: 0.35, ease: 'power3' }), cy = gsap.quickTo(cur, 'y', { duration: 0.35, ease: 'power3' });
    addEventListener('mousemove', e => { cx(e.clientX); cy(e.clientY); });
  }

  /* ---------- Magnet ---------- */
  if (fine && !reduce) $$('[data-magnet]').forEach(el => {
    const qx = gsap.quickTo(el, 'x', { duration: 0.6, ease: 'power3' }), qy = gsap.quickTo(el, 'y', { duration: 0.6, ease: 'power3' });
    el.addEventListener('mousemove', e => { const r = el.getBoundingClientRect(); qx((e.clientX - r.left - r.width / 2) * 0.25); qy((e.clientY - r.top - r.height / 2) * 0.35); });
    el.addEventListener('mouseleave', () => { qx(0); qy(0); });
  });

  /* ---------- Cookie banner (Shopify): keep cart button, sticky bar and sheet above it on phones ---------- */
  (() => {
    let watched = null;
    const sync = () => {
      const b = document.getElementById('shopify-pc__banner');
      let h = 0;
      if (b && innerWidth < 900) {
        const cs = getComputedStyle(b), r = b.getBoundingClientRect();
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0 && r.height > 0 && r.top < innerHeight) h = Math.ceil(innerHeight - r.top + 8);
      }
      document.documentElement.style.setProperty('--consent-h', h + 'px');
      if (b && b !== watched) {
        watched = b;
        // shorter German text (Shopify's default fills half a phone screen); title, buttons and policy link stay Shopify's
        const link = b.querySelector('#shopify-pc__banner__body-policy-link'), para = link?.closest('p');
        if (para && !para.dataset.wan) {
          para.dataset.wan = '1';
          para.textContent = 'Wir nutzen Cookies für Analysen und personalisierte Werbung, nur mit deiner Zustimmung. Mehr dazu in unserer ';
          link.textContent = 'Datenschutzerklärung';
          para.append(link, '.');
        }
        new MutationObserver(sync).observe(b, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
        if ('ResizeObserver' in window) new ResizeObserver(sync).observe(b);
      }
    };
    new MutationObserver(sync).observe(document.body, { childList: true });
    addEventListener('resize', sync);
    document.addEventListener('click', e => { if (e.target.closest('#shopify-pc__banner')) setTimeout(sync, 400); });
    sync();
  })();

  /* ---------- Newsletter ---------- */
  $('#newsForm')?.addEventListener('submit', e => {
    const i = $('#newsMail'), ok = $('.news__ok');
    // Shopify: a real customer form (newsletter tag, synced to Klaviyo); only stop it when the address is invalid
    if (SHOP && /.+@.+\..+/.test(i.value)) return;
    e.preventDefault();
    ok.textContent = /.+@.+\..+/.test(i.value) ? 'Danke! Bitte bestätige deine Anmeldung per E-Mail.' : 'Bitte gib eine gültige E-Mail-Adresse ein.';
  });

  if (document.body.dataset.page === 'home') home();
  if (document.body.dataset.page === 'produkt') pdp();

  /* ===================================================================== */
  function home() {
    /* ---------- Product rail ---------- */
    const railApi = initRail($('#rail'), P, { bar: $('#railBar'), prev: $('#railPrev'), next: $('#railNext') });
    const track = railApi.track;

    // filter chips
    const chips = $('#needChips');
    chips.innerHTML = (window.WAN_NEEDS || []).map(([k, l], i) => `<button class="chip${i ? '' : ' is-on'}" role="tab" aria-selected="${!i}" data-need="${k}">${l}</button>`).join('');
    chips.addEventListener('click', e => {
      const b = e.target.closest('.chip'); if (!b) return;
      $$('.chip', chips).forEach(c => { c.classList.toggle('is-on', c === b); c.setAttribute('aria-selected', c === b); });
      const need = b.dataset.need;
      const cards = $$('.card', track);
      const show = cards.filter(c => need === 'alle' || c.dataset.need === need);
      const hide = cards.filter(c => !show.includes(c));
      // FLIP: move matching cards to the front
      const first = new Map(cards.map(c => [c, c.getBoundingClientRect().left]));
      [...show, ...hide].forEach(c => track.appendChild(c));
      hide.forEach(c => c.classList.add('is-out')); show.forEach(c => c.classList.remove('is-out'));
      railApi.reset();
      cards.forEach(c => { const d = first.get(c) - c.getBoundingClientRect().left; gsap.fromTo(c, { x: d }, { x: 0, duration: 1, ease: 'expo.out' }); });
      railApi.measure();
    });

    /* ---------- Hero hotspots ---------- */
    const phoneQ = matchMedia('(max-width: 760px)');
    function closeSpots() {
      $$('.spot.is-open').forEach(s => { s.classList.remove('is-open'); s.querySelector('button').setAttribute('aria-expanded', 'false'); });
      if (sheet.classList.contains('is-open')) closeSheet(false);
    }
    const SPOTS = {
      wide: [['ashwagandha', 47, 36, ''], ['omega3', 71.4, 39, ''], ['nad', 59.3, 16, 'below'], ['kollagen', 85, 36, 'left']],
      square: [['ashwagandha', 18.2, 36, 'below'], ['omega3', 58, 39, 'below'], ['nad', 38.2, 16, 'below'], ['kollagen', 80.1, 36, 'below left']]
    };
    $$('[data-spots]').forEach(frame => {
      SPOTS[frame.dataset.spots].forEach(([id, l, t, cls]) => {
        const p = byId[id];
        const b = document.createElement('div');
        b.className = 'spot ' + cls.split(' ').filter(Boolean).map(c => 'spot--' + c).join(' ');
        b.style.left = l + '%'; b.style.top = t + '%';
        b.innerHTML = `<button aria-label="${p.name} ansehen" aria-expanded="false"><svg><use href="#i-plus"/></svg></button>
          <div class="spot__card"><img src="${prodImg(id)}" alt=""><div><b>${p.name}</b><small>${p.type}</small>
          <span class="spot__price">${priceHTML(p.price)}</span><a class="spot__go" href="#" data-add="${id}">In den Warenkorb</a></div></div>`;
        b.querySelector('button').style.cssText = 'position:absolute;inset:0;display:grid;place-items:center;z-index:1';
        b.querySelector('button svg').style.cssText = 'width:14px;height:14px';
        b.querySelector('button').addEventListener('click', () => {
          const on = !b.classList.contains('is-open');
          closeSpots();
          if (!on) return;
          b.classList.add('is-open'); b.querySelector('button').setAttribute('aria-expanded', 'true');
          // phones: a bottom sheet above everything instead of a card clipped by the photo
          if (phoneQ.matches) openSheet(id, b);
        });
        frame.appendChild(b);
      });
    });
    // pointerdown (not click): iOS does not send clicks from non-interactive areas to document
    document.addEventListener('pointerdown', e => { if (!e.target.closest('.spot, .psheet')) closeSpots(); });

    /* ---------- Leaf shadows (dappled light over the wall) ----------
       Each branch is drawn once into a small, soft canvas. Swaying is then a pure GPU
       transform: no live blur, no blend mode, nothing repainted per frame. */
    const leafBox = $('#heroLeaves');
    const leafTweens = [];
    function drawBranch(ctx, x, y, ang, len, n, size, seed) {
      const rad = ang * Math.PI / 180;
      const ex = x + Math.cos(rad) * len, ey = y + Math.sin(rad) * len;
      const cx = (x + ex) / 2 + Math.sin(rad) * 40, cy = (y + ey) / 2 - Math.cos(rad) * 40;
      ctx.lineWidth = 5; ctx.beginPath(); ctx.moveTo(x, y); ctx.quadraticCurveTo(cx, cy, ex, ey); ctx.stroke();
      for (let i = 1; i <= n; i++) {
        const t = i / (n + 1), it = 1 - t;
        const px = it * it * x + 2 * it * t * cx + t * t * ex, py = it * it * y + 2 * it * t * cy + t * t * ey;
        [-1, 1].forEach(side => {
          const r = ((seed * 9301 + i * 49297 + side * 233) % 233280) / 233280;
          const a = (ang + side * (38 + r * 22)) * Math.PI / 180;
          const sz = size * (0.75 + r * 0.45) * (1 - t * 0.35);
          ctx.save(); ctx.translate(px, py); ctx.rotate(a); ctx.beginPath();
          ctx.moveTo(0, 0); ctx.bezierCurveTo(sz * 0.35, -sz * 0.2, sz * 0.75, -sz * 0.17, sz, 0);
          ctx.bezierCurveTo(sz * 0.75, sz * 0.17, sz * 0.35, sz * 0.2, 0, 0); ctx.fill(); ctx.restore();
        });
      }
    }
    const BRANCHES = [[-60, 80, 22, 820, 11, 120, 3], [-40, 420, 8, 640, 9, 104, 7], [120, -60, 58, 600, 8, 96, 11]];
    function buildLeaves() {
      leafTweens.forEach(t => t.kill()); leafTweens.length = 0; leafBox.innerHTML = '';
      const w = leafBox.clientWidth, h = leafBox.clientHeight;
      if (!w || !h || getComputedStyle(leafBox).display === 'none') return;
      const k = Math.max(w, h) / 1000, ox = (w - 1000 * k) / 2, oy = (h - 1000 * k) / 2; // like "slice"
      const res = 0.32; // low resolution on purpose: upscaling makes the shadow soft for free
      BRANCHES.forEach((b, i) => {
        const c = document.createElement('canvas');
        c.width = Math.ceil(w * res); c.height = Math.ceil(h * res);
        const ctx = c.getContext('2d');
        if ('filter' in ctx) ctx.filter = 'blur(2px)';
        ctx.fillStyle = ctx.strokeStyle = '#5B3E24';
        ctx.setTransform(k * res, 0, 0, k * res, ox * res, oy * res);
        drawBranch(ctx, ...b);
        c.style.transformOrigin = `${ox + b[0] * k}px ${oy + b[1] * k}px`;
        leafBox.appendChild(c);
        if (!reduce) leafTweens.push(gsap.to(c, { rotation: i % 2 ? -2.6 : 2.2, skewX: i % 2 ? 1.5 : -1.2, duration: 4.5 + i * 1.3, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: i * 0.7 }));
      });
      whenVisible($('.hero'), leafTweens);
    }
    buildLeaves();
    let leafW = innerWidth;
    addEventListener('resize', () => { if (Math.abs(innerWidth - leafW) > 40) { leafW = innerWidth; buildLeaves(); } });

    /* ---------- Hero intro ---------- */
    const titleLines = prepLines($('.hero__title'));
    const heroIns = $$('[data-hero-in]');
    gsap.set(titleLines, { yPercent: 110 });
    gsap.set(heroIns, { y: 26, opacity: 0 });
    gsap.set('.hero__frame', { scale: reduce ? 1 : 1.04 });
    gsap.set('.spot', { scale: 0 });
    function heroIn() {
      if (reduce) {
        gsap.set(titleLines, { yPercent: 0 });
        gsap.set(heroIns, { y: 0, opacity: 1 });
        gsap.set('.spot', { scale: 1 });
        return;
      }
      const tl = gsap.timeline();
      tl.to('.hero__frame', { scale: 1, duration: 2.6, ease: 'expo.out' }, 0)
        .to(titleLines, { yPercent: 0, stagger: 0.07, duration: 1.5 }, 0.15)
        .to(heroIns, { y: 0, opacity: 1, stagger: 0.07, duration: 1.2 }, 0.45)
        .to('.spot', { scale: 1, stagger: 0.08, duration: 0.9, ease: 'back.out(2)' }, 1.0);
    }

    // no intro loader: first visits (ad traffic) see the hero immediately
    $('#loader')?.remove();
    heroIn();

    /* ---------- Hero scroll + mouse depth ---------- */
    if (!reduce) {
      gsap.timeline({ scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } })
        .to('.hero__media', { yPercent: 18, ease: 'none' }, 0)
        .to('.hero__copy', { yPercent: -18, opacity: 0, ease: 'none' }, 0)
        .to('.hero__leaves', { yPercent: -10, ease: 'none' }, 0);
      if (fine) {
        const media = $('.hero__media');
        const lx = gsap.quickTo('.hero__leaves', 'x', { duration: 1.8, ease: 'power3' });
        const ly = gsap.quickTo('.hero__leaves', 'y', { duration: 1.8, ease: 'power3' });
        $('.hero').addEventListener('mousemove', e => {
          const r = media.getBoundingClientRect();
          const nx = (e.clientX - r.left) / r.width - 0.5, ny = (e.clientY - r.top) / r.height - 0.5;
          lx(nx * 34); ly(ny * 20);
        });
        $('.hero').addEventListener('mouseleave', () => { lx(0); ly(0); });
      }
    }

    document.fonts.ready.then(() => {
      /* ---------- Line reveals ---------- */
      $$('[data-reveal-lines]').forEach(el => {
        const lines = prepLines(el);
        if (reduce) return;
        gsap.set(lines, { yPercent: 110 });
        ScrollTrigger.create({ trigger: el, start: 'top 85%', once: true, onEnter: () => gsap.to(lines, { yPercent: 0, stagger: 0.05, duration: 1.3 }) });
      });
      if (!reduce) $$('[data-fade]').forEach(el => {
        enter(el, { y: 36, opacity: 0 }, { y: 0, opacity: 1, duration: 1.3 }, el, 'top 90%');
      });

      /* ---------- Statement: words light up while scrolling ---------- */
      const st = $('#statement');
      const words = splitWords(st);
      if (!reduce) {
        const tl = gsap.timeline({ scrollTrigger: { trigger: st, start: 'top 80%', end: 'bottom 45%', scrub: 0.6 } });
        const items = [...st.querySelectorAll('.w, .pill')];
        items.forEach((n, i) => {
          if (n.classList.contains('pill')) tl.to(n, { scale: 1, opacity: 1, duration: 0.6, ease: 'back.out(2)' }, i * 0.18);
          else tl.to(n, { opacity: 1, duration: 0.4, ease: 'none' }, i * 0.18);
        });
        enter('.pillar', { y: 50, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.12, duration: 1.3 }, '.pillars', 'top 85%');
      } else words.forEach(w => (w.style.opacity = 1));

      ScrollTrigger.refresh();
    });


    /* ---------- NAD+ scene ---------- */
    const canvas = $('#nadCells'), ctx = canvas.getContext('2d');
    let cw = 0, ch = 0, dpr = 1, center = { x: 0, y: 0 }, intensity = 0.4, nadOn = false;
    const parts = [];
    function sizeCanvas() {
      dpr = Math.min(devicePixelRatio || 1, 1.5);
      const r = canvas.getBoundingClientRect(); cw = r.width; ch = r.height;
      canvas.width = cw * dpr; canvas.height = ch * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const b = $('.nad__bottle').getBoundingClientRect();
      center = { x: b.left - r.left + b.width / 2, y: b.top - r.top + b.height * 0.55 };
    }
    function spawn(p, far) {
      const a = Math.random() * Math.PI * 2, d = (far ? 0.6 + Math.random() * 0.5 : Math.random()) * Math.max(cw, ch) * 0.75;
      Object.assign(p, { a, d, s: 0.15 + Math.random() * 0.5, r: 0.6 + Math.random() * 2.2, w: (Math.random() - 0.5) * 0.004 });
    }
    for (let i = 0, n = innerWidth < 761 ? 70 : 130; i < n; i++) { const p = {}; parts.push(p); }
    function drawCells(t) {
      ctx.clearRect(0, 0, cw, ch);
      // cell rings
      for (let i = 0; i < 5; i++) {
        const k = ((t * 0.00005 + i / 5) % 1);
        const rad = 120 + k * Math.max(cw, ch) * 0.6;
        ctx.beginPath(); ctx.arc(center.x, center.y, rad, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(201,164,107,${(1 - k) * 0.16 * (0.6 + intensity)})`; ctx.lineWidth = 1; ctx.stroke();
      }
      parts.forEach(p => {
        p.d -= p.s * (0.6 + intensity * 1.6); p.a += p.w + 0.0015;
        if (p.d < 60) spawn(p, true);
        const x = center.x + Math.cos(p.a) * p.d, y = center.y + Math.sin(p.a) * p.d * 0.8;
        const near = Math.min(1, p.d / 300);
        ctx.beginPath(); ctx.arc(x, y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(231,210,166,${(0.15 + intensity * 0.5) * near})`; ctx.fill();
      });
    }
    if (!reduce) {
      parts.forEach(p => spawn(p, false));
      ScrollTrigger.create({ trigger: '#nad', start: 'top bottom', end: 'bottom top', onToggle: s => { nadOn = s.isActive; if (nadOn) sizeCanvas(); } });
      gsap.ticker.add(t => nadOn && drawCells(t * 1000));
      addEventListener('resize', () => nadOn && sizeCanvas());
    }
    const steps = $$('.nad__step'), dots = $$('.nad__dots i');
    let stepIdx = 0;
    function setStep(i) {
      if (i === stepIdx) return;
      stepIdx = i;
      steps.forEach((s, k) => {
        gsap.killTweensOf(s);
        if (k === i) { s.classList.add('is-on'); gsap.fromTo(s, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.9, delay: 0.2 }); }
        else { s.classList.remove('is-on'); gsap.to(s, { opacity: 0, y: -16, duration: 0.4, ease: 'power2.in' }); }
      });
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      intensity = 0.4 + i * 0.3;
    }
    const counter = $('[data-count]');
    mm.add('(min-width: 761px)', () => {
      if (reduce) return;
      const tl = gsap.timeline({ scrollTrigger: { trigger: '#nad', start: 'top top', end: '+=180%', pin: '.nad__pin', scrub: 0.8,
        onUpdate: s => setStep(Math.min(2, Math.floor(s.progress * 3 * 0.999))) } });
      tl.fromTo('.nad__bottle', { y: 90, rotation: -8, scale: 0.86 }, { y: -10, rotation: 4, scale: 1.04, ease: 'none' }, 0)
        .fromTo('.nad__halo', { scale: 0.7, opacity: 0.4 }, { scale: 1.2, opacity: 1, ease: 'none' }, 0)
        .fromTo('.nad__stat--a', { y: 80, opacity: 0 }, { y: -30, opacity: 1, ease: 'none', duration: 0.4 }, 0.05)
        .fromTo('.nad__stat--b', { y: 120, opacity: 0 }, { y: 0, opacity: 1, ease: 'none', duration: 0.4 }, 0.35)
        .fromTo('.nad__tags li', { y: 20, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.04, duration: 0.2 }, 0.5);
      return () => { steps.forEach((s, k) => { s.classList.toggle('is-on', k === 0); gsap.set(s, { clearProps: "all" }); }); stepIdx = 0; };
    });
    ScrollTrigger.create({ trigger: '.nad__stat--a', start: 'top 95%', once: true, onEnter: () => {
      const o = { v: 0 }; gsap.to(o, { v: 100, duration: 2.2, ease: 'power2.out', onUpdate: () => (counter.textContent = Math.round(o.v)) });
    } });
    if (reduce) counter.textContent = '100';
    if (!reduce) whenVisible($('#nad'), [gsap.to('.nad__bottle', { y: '+=10', duration: 3, ease: 'sine.inOut', yoyo: true, repeat: -1 })]);

    /* ---------- Ritual: morning to night (same scene on desktop and phones) ---------- */
    mm.add({ phone: '(max-width: 760px)', desk: '(min-width: 761px)' }, ctx => {
      if (reduce) return;
      const phone = ctx.conditions.phone;
      const tr = $('#ritualTrack'), pin = $('.ritual__pin');
      // panels are 100vw each; scrollWidth would also count artwork that overflows a panel
      const dist = () => tr.lastElementChild.offsetLeft;
      const clock = $$('.ritual__clock button');
      const COLORS = ['#F7DCC4', '#EEE3CF', '#1A3B35', '#122E28'];
      const sun = $('#ritualSun');
      const H = 0.35; // hold on the first and last panel
      const T = 3 + H * 2;
      // panel i is centred at timeline time H + i (last panel at 3 + H)
      const stops = [0, (H + 1) / T, (H + 2) / T, 1];
      const setClock = p => {
        const i = Math.max(0, Math.min(2, Math.round(p * T - H)));
        clock.forEach((c, k) => { c.classList.toggle('is-on', k === i); c.setAttribute('aria-pressed', k === i); });
      };
      const tl = gsap.timeline({ scrollTrigger: {
        trigger: '#ritual', start: 'top top', pin: pin, scrub: phone ? 0.6 : 1, invalidateOnRefresh: true, anticipatePin: 1,
        // phones get more scroll per panel so a swipe moves one step, not three
        end: () => '+=' + dist() * (phone ? 2.1 : 1.35),
        snap: { snapTo: stops, directional: false, inertia: false, duration: { min: 0.25, max: 0.7 }, delay: phone ? 0.08 : 0.15, ease: 'power2.inOut' },
        onUpdate: s => setClock(s.progress)
      } });
      tl.to(tr, { x: () => -dist(), ease: 'none', duration: 3 }, H)
        .to(pin, { backgroundColor: COLORS[1], duration: 1, ease: 'none' }, H)
        .to(pin, { backgroundColor: COLORS[2], duration: 1, ease: 'none' }, H + 1)
        .to(pin, { backgroundColor: COLORS[3], duration: 1, ease: 'none' }, H + 2)
        .fromTo(sun, { rotation: phone ? -20 : -26 }, { rotation: phone ? 20 : 30, duration: T, ease: 'none' }, 0)
        .to(sun, { background: 'radial-gradient(circle at 40% 40%, #FFF6E2, #EAD7AE 60%, #C9A46B)', boxShadow: '0 0 48px 12px rgba(231,210,166,.15)', '--moon': 1, duration: 0.6, ease: 'none' }, H + 1.5)
        .to('.ritual__arc', { borderColor: 'rgba(231,210,166,.2)', duration: 0.6, ease: 'none' }, H + 1.5)
        .to('.ritual__clock', { backgroundColor: 'rgba(244,238,230,.1)', color: '#F4EEE6', '--on-bg': '#C9A46B', '--on-fg': '#122E28', duration: 0.5 }, H + 1.5)
        .to({}, { duration: H }, 3 + H);
      // portrait drift and text entrances ride on the same timeline
      $$('.rp').forEach((panel, i) => {
        const person = $('.rp__person', panel), copy = $('.rp__copy', panel), collection = $$('.rp__product-row', panel);
        if (person) tl.fromTo(person, { xPercent: phone ? 3 : 2 }, { xPercent: phone ? -3 : -2, duration: 1.4, ease: 'none' }, Math.max(0, H + i - 0.7));
        if (i && copy) tl.fromTo(copy.children, { x: phone ? 36 : 50, opacity: 0 }, { x: 0, opacity: 1, stagger: 0.04, duration: 0.45, ease: 'power1.out' }, H + i - 0.65);
        if (collection.length) tl.fromTo(collection, { yPercent: 30, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.5, ease: 'power1.out' }, H + i - 0.65);
      });
      // the time pills jump to their panel
      const jump = e => {
        const k = clock.indexOf(e.currentTarget), st = tl.scrollTrigger;
        const y = st.start + (st.end - st.start) * stops[k];
        lenis ? lenis.scrollTo(y, { duration: 1.2 }) : scrollTo({ top: y, behavior: 'smooth' });
      };
      clock.forEach(c => c.addEventListener('click', jump));
      setClock(0);
      return () => { clock.forEach(c => c.removeEventListener('click', jump)); gsap.set([pin, sun, tr], { clearProps: 'all' }); };
    });

    /* ---------- Voices ---------- */
    const quotes = $$('.quote'), tabs = $$('.voices__tabs button'), bottles = $$('.voices__bottle');
    const quoteWords = quotes.map(q => splitWords($('p', q)));
    let qi = 0, qTimer = null, qProg = null;
    const DISC = { shilajit: '#E2D2C4', ashwagandha: '#DCDDC9', schlaf: '#DCD9E0' };
    function showQuote(i, instant) {
      if (i === qi && !instant) return;
      const prev = qi; qi = i;
      tabs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i); t.style.setProperty('--p', k < i ? 1 : 0); });
      quotes.forEach((q, k) => q.classList.toggle('is-on', k === i));
      const id = quotes[i].dataset.product;
      $('.voices__disc').style.background = `radial-gradient(circle at 50% 35%, #FFF7EC, ${DISC[id]} 70%)`;
      if (!reduce) {
        gsap.fromTo(quoteWords[i], { opacity: 0, y: 14 }, { opacity: 1, y: 0, stagger: 0.012, duration: 0.9 });
        gsap.fromTo($('footer', quotes[i]), { opacity: 0 }, { opacity: 1, delay: 0.4 });
        const out = bottles.find(b => b.classList.contains('is-on'));
        const inn = bottles.find(b => b.dataset.id === id);
        if (out && out !== inn) { out.classList.remove('is-on'); gsap.fromTo(out, { opacity: 1, x: 0, rotation: 0 }, { opacity: 0, x: -120, rotation: -16, duration: 0.8, ease: 'power3.in' }); }
        inn.classList.add('is-on');
        gsap.fromTo(inn, { opacity: 0, x: 140, rotation: 18, scale: 0.9 }, { opacity: 1, x: 0, rotation: 0, scale: 1, duration: 1.4, delay: 0.35 });
      } else { bottles.forEach(b => b.classList.toggle('is-on', b.dataset.id === id)); }
      runTimer();
    }
    function runTimer() {
      clearTimeout(qTimer); qProg?.kill();
      if (reduce) return;
      const tab = tabs[qi];
      qProg = gsap.fromTo(tab, { '--p': 0 }, { '--p': 1, duration: 8, ease: 'none', onComplete: () => showQuote((qi + 1) % quotes.length) });
      qProg.pause();
      if (voicesVisible) qProg.play();
    }
    let voicesVisible = false;
    ScrollTrigger.create({ trigger: '.voices', start: 'top 70%', end: 'bottom 30%', onToggle: s => { voicesVisible = s.isActive; if (qProg) s.isActive ? qProg.play() : qProg.pause(); } });
    tabs.forEach((t, k) => t.addEventListener('click', () => showQuote(k)));
    // swipe between quotes on touch screens
    let sx = 0, sy = 0;
    const vg = $('.voices__grid');
    vg.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    vg.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) showQuote((qi + (dx < 0 ? 1 : quotes.length - 1)) % quotes.length);
    }, { passive: true });
    showQuote(0, true);
    if (!reduce) enter('.voices__disc', { scale: 0.6, opacity: 0 }, { scale: 1, opacity: 1, duration: 1.8 }, '.voices', 'top 75%');


    /* ---------- FAQ ---------- */
    const F = window.WAN_FAQ;
    if (F && $('#faq')) {
      const tabs = $('#faqTabs'), lists = $('#faqLists');
      tabs.innerHTML = F.categories.map((c, i) => `<button class="faq__tab${i ? '' : ' is-on'}" role="tab" id="faqTab-${c.id}" aria-selected="${!i}" aria-controls="faqList-${c.id}">${c.title}</button>`).join('');
      lists.innerHTML = F.categories.map((c, i) => `<div class="faq__list acc" id="faqList-${c.id}" role="tabpanel" aria-labelledby="faqTab-${c.id}"${i ? ' hidden' : ''}>${c.items.map(([q, a], k) => `
        <div class="acc__item"><h3><button class="acc__btn" aria-expanded="false" aria-controls="faq-${c.id}-${k}" id="faqq-${c.id}-${k}">${q}<i class="acc__icon" aria-hidden="true"></i></button></h3>
        <div class="acc__panel" id="faq-${c.id}-${k}" role="region" aria-labelledby="faqq-${c.id}-${k}"><div class="acc__body"><p>${a.replace('{sale}', SALE ? ` Aktuell läuft der ${SALE.name}: zusätzlich ${SALE.pct} % auf die gesamte Bestellung.` : '').replace(/support@wearenaturals\.de/g, '<a href="mailto:support@wearenaturals.de">support@wearenaturals.de</a>')}</p></div></div></div>`).join('')}</div>`).join('');
      const ct = F.contact;
      $('#faqContact').innerHTML = `<h3>${ct.title}</h3><p>${ct.text}</p><div class="faq__links">
        <a href="mailto:${ct.email}"><svg aria-hidden="true"><use href="#i-chat"/></svg>${ct.email}</a>
        <a href="${ct.form}"><svg aria-hidden="true"><use href="#i-arrow"/></svg>Kontaktformular</a></div>`;
      tabs.addEventListener('click', e => {
        const b = e.target.closest('.faq__tab'); if (!b || b.classList.contains('is-on')) return;
        $$('.faq__tab', tabs).forEach(t => { const on = t === b; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
        $$('.faq__list', lists).forEach(l => { l.hidden = l.id !== b.getAttribute('aria-controls'); });
        const shown = $('#' + b.getAttribute('aria-controls'));
        if (!reduce) gsap.fromTo(shown.children, { y: 18, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.04, duration: 0.7 });
        ScrollTrigger.refresh();
      });
      lists.addEventListener('click', e => {
        const b = e.target.closest('.acc__btn'); if (!b) return;
        const item = b.closest('.acc__item'), panel = item.querySelector('.acc__panel'), open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
        if (reduce) { panel.style.height = open ? 'auto' : '0px'; return; }
        gsap.fromTo(panel, { height: panel.offsetHeight }, { height: open ? panel.scrollHeight : 0, duration: 0.6, ease: 'expo.out', onComplete: () => { if (open) panel.style.height = 'auto'; ScrollTrigger.refresh(); } });
      });
      const schema = $('#faqSchema');
      if (schema) schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage',
        mainEntity: F.categories.flatMap(c => c.items.map(([q, a]) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a.replace('{sale}', '') } }))) });
      if (!reduce) {
        enter('.faq__tabs, .faq__contact', { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.1, duration: 1.2 }, '#faq', 'top 75%');
        enter('#faqList-produkte .acc__item', { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.05, duration: 1 }, '#faqLists', 'top 85%');
      }
    }

    /* ---------- Community parallax ---------- */
    if (!reduce) {
      $$('[data-speed]').forEach(el => gsap.to(el, { yPercent: +el.dataset.speed * 100, ease: 'none', scrollTrigger: { trigger: '.community', start: 'top bottom', end: 'bottom top', scrub: true } }));
      enter('.arch', { clipPath: 'inset(100% 0% 0% 0% round 999px 999px 24px 24px)' }, { clipPath: 'inset(0% 0% 0% 0% round 999px 999px 24px 24px)', stagger: 0.14, duration: 1.8, ease: 'expo.inOut' }, '.community__people', 'top 80%');
      enter('.arch img', { scale: 1.3 }, { scale: 1, stagger: 0.14, duration: 2.2 }, '.community__people', 'top 80%');
      whenVisible($('.community'), [gsap.to('.community__emblem', { rotation: 360, duration: 40, ease: 'none', repeat: -1 })]);

      /* Instagram */
      enter('.post', { y: 120, opacity: 0, rotation: i => (i % 2 ? 4 : -4) }, { y: 0, opacity: 1, rotation: 0, stagger: 0.1, duration: 1.6 }, '.insta__grid', 'top 85%');
      if (fine) $$('.post').forEach(p => {
        const rx = gsap.quickTo(p, 'rotationY', { duration: 0.6 }), ry = gsap.quickTo(p, 'rotationX', { duration: 0.6 });
        p.style.transformPerspective = '900px';
        p.addEventListener('mousemove', e => { const r = p.getBoundingClientRect(); rx(((e.clientX - r.left) / r.width - 0.5) * 10); ry(-((e.clientY - r.top) / r.height - 0.5) * 10); });
        p.addEventListener('mouseleave', () => { rx(0); ry(0); });
      });

    }
  }


  /* ===================================================================== */
  /* PRODUCT PAGE                                                          */
  /* ===================================================================== */
  function pdp() {
    const D = window.WAN_PDP || {}, S = window.WAN_PDP_SHARED || {}, G = window.WAN_GALLERY || {};
    const qid = SHOP ? document.body.dataset.product : new URLSearchParams(location.search).get('p');
    const id = byId[qid] ? qid : 'nad';
    const p = byId[id], d = D[id] || { bullets: [], description: [], accordions: [], quotes: [], spotlight: {}, quality: {} };
    const cutout = prodImg(id, 800);
    const wide = id === 'shilajit';
    const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const tinted = el => el && el.style.setProperty('--t', p.tint);

    /* ---------- head: title, description, schema ---------- */
    document.title = `${p.name} · We Are Naturals`;
    const descText = (d.description[0] || p.full).slice(0, 155);
    $('meta[name="description"]')?.setAttribute('content', descText);
    const schema = $('#productSchema');
    if (schema) schema.textContent = JSON.stringify({
      '@context': 'https://schema.org', '@type': 'Product', name: p.full, description: descText,
      image: [new URL(cutout, location.href).href], brand: { '@type': 'Brand', name: 'We Are Naturals' },
      offers: { '@type': 'Offer', price: p.price.toFixed(2), priceCurrency: 'EUR', availability: 'https://schema.org/InStock', url: location.href }
    });

    /* ---------- buy box ---------- */
    $('#crumbName').textContent = p.name;
    const chipIcons = ['i-scale', 'i-sun'];
    $('#pdSub').innerHTML = `<li><svg aria-hidden="true"><use href="#i-leaf"/></svg>${esc(p.type)}</li>` + (d.subtitle || '').split('|').map(t => t.trim()).filter(Boolean)
      .map((t, i) => `<li><svg aria-hidden="true"><use href="#${chipIcons[i] || 'i-check'}"/></svg>${esc(t)}</li>`).join('');
    $('#pdTitle').textContent = p.name;
    $('#pdFull').textContent = p.full !== p.name ? p.full : '';
    $('#pdPrice').innerHTML = priceHTML(p.price);
    if (SALE) $('#pdPrice').insertAdjacentHTML('afterend', `<em class="sale-tag">${SALE.name} −${SALE.pct} %</em>`);
    const checkSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    $('#pdBullets').innerHTML = d.bullets.map(b => `<li><span class="pd__check">${checkSvg}</span><span>${esc(b)}</span></li>`).join('');
    const TRUST_ICONS = ['i-truck', 'i-card', 'i-return', 'i-chat'];
    // the monitored channel is the support mailbox (named on the live Versand and Widerruf pages)
    $('#pdTrust').innerHTML = (S.trust || []).map((t, i) => {
      const icon = `<svg aria-hidden="true"><use href="#${TRUST_ICONS[i] || 'i-check'}"/></svg>`;
      return /support/i.test(t) ? `<li><a href="mailto:support@wearenaturals.de">${icon}Support per E-Mail</a></li>` : `<li>${icon}${esc(t)}</li>`;
    }).join('');

    // delivery window like the live shop: tomorrow to five days out
    const fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    const day = n => { const x = new Date(); x.setDate(x.getDate() + n); return fmt.format(x); };
    $('#pdDelivery').textContent = `${day(1)} bis ${day(5)}`;

    /* ---------- dose selector: 1 Dose, 2 Dosen (−15 %), 3 Dosen (−20 %) ---------- */
    // how long one dose lasts, read from the subtitle ("60 Portionen | 2 Monate") or the first bullet
    const reach = (() => {
      const src = `${d.subtitle || ''} ${d.bullets[0] || ''}`;
      const t = src.match(/(\d+)\s*(Monate?|Tage|Wochen)\b/);
      if (t && !/bis\s*$/.test(src.slice(0, t.index))) return { n: +t[1], unit: t[2].startsWith('Monat') ? 'm' : t[2] === 'Tage' ? 'd' : 'w' };
      const pt = src.match(/(ca\.\s*)?(\d+)\s*Portionen/);
      return pt ? { n: +pt[2], unit: 'p', ca: !!pt[1] } : null;
    })();
    const reachText = k => {
      if (!reach) return '';
      const v = reach.n * k;
      if (reach.unit === 'm') return `${v} ${v === 1 ? 'Monat' : 'Monate'}`;
      if (reach.unit === 'd') return v % 30 === 0 ? `${v / 30} ${v === 30 ? 'Monat' : 'Monate'}` : `${v} Tage`;
      if (reach.unit === 'w') return `${v} Wochen`;
      return `${reach.ca ? 'ca. ' : ''}${v} Portionen`;
    };
    const bundleImg = (k, w = 240) => k === 1 ? prodImg(id) : `${img(`products/bundle/${id}-${k}-${w}.webp`)}`;
    let qty = DEFAULT_DOSE;
    $('#pdDose').innerHTML = [1, 2, 3].map(k => {
      const full = p.price * k, now = lineTotal(p.price, k);
      return `<button type="button" class="dose__opt${k === 3 ? ' dose__opt--best' : ''}" role="radio" aria-checked="${k === qty}" data-k="${k}" style="--t:${p.tint}">
        ${k === 3 ? '<span class="dose__flag">Bestes Angebot</span>' : ''}
        <span class="dose__img"><img src="${bundleImg(k)}" srcset="${bundleImg(k)} 240w${k > 1 ? `, ${bundleImg(k, 480)} 480w` : `, ${prodImg(id, 800)} 800w`}" sizes="120px" alt="" loading="lazy" decoding="async"></span>
        <span class="dose__save">${k === 1 ? 'Einzeln' : `Spare ${Math.round(doseRate(k) * 100)} %`}</span>
        <b class="dose__n">${k} ${k === 1 ? 'Dose' : 'Dosen'}</b>
        ${reach ? `<span class="dose__reach">${reachText(k)}</span>` : ''}
        <span class="dose__price">${k > 1 || SALE ? `<s>${euro(full)}</s>` : ''}<b>${euro(salePrice(now))}</b></span>
        <span class="dose__per">${euro(salePrice(doseUnit(p.price, k)))} / Dose</span>
      </button>`;
    }).join('');
    const opts = $$('.dose__opt');
    function syncBuy(animate) {
      opts.forEach(o => { const on = +o.dataset.k === qty; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on); o.tabIndex = on ? 0 : -1; });
      const full = p.price * qty, now = salePrice(lineTotal(p.price, qty));
      const saleNote = SALE ? ` inkl. ${SALE.pct} % ${SALE.name}` : '';
      $('#pdSum').textContent = euro(now);
      $('#pdBarPrice').textContent = qty > 1 ? `${qty} Dosen · ${euro(now)}` : euro(now);
      $('#pdDoseTip').innerHTML = qty === 1
        ? `${SALE ? `Du sparst <b>${euro(full - now)}</b>${saleNote}. ` : ''}Tipp: Mit 2 Dosen sparst du 15 %, mit 3 Dosen 20 %${SALE ? ' extra' : ''}${reach ? ` und bist ${reachText(3)} versorgt` : ''}.`
        : `Du sparst <b>${euro(full - now)}</b>${saleNote}${reach ? ` und bist ${reachText(qty)} versorgt` : ''}. Der Rabatt ist im Preis schon abgezogen.`;
      if (animate && !reduce) gsap.fromTo('#pdSum, #pdDoseTip', { y: 8, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, stagger: 0.05 });
    }
    $('#pdDose').addEventListener('click', e => {
      const o = e.target.closest('.dose__opt'); if (!o || +o.dataset.k === qty) return;
      qty = +o.dataset.k; syncBuy(1);
      if (!reduce) gsap.fromTo(o.querySelector('.dose__img img'), { scale: 0.86, y: 8 }, { scale: 1, y: 0, duration: 0.7, ease: 'back.out(2.2)' });
    });
    // arrow keys move between options like a native radio group
    $('#pdDose').addEventListener('keydown', e => {
      if (!/Arrow(Left|Right|Up|Down)/.test(e.key)) return;
      e.preventDefault();
      qty = Math.min(3, Math.max(1, qty + (/Right|Down/.test(e.key) ? 1 : -1)));
      syncBuy(1); opts[qty - 1].focus();
    });
    syncBuy(0);

    function buy(btn) {
      if (btn.classList.contains('is-done')) return;
      addToCart(id, $('.pd__hero') || btn, qty);
      const label = btn.querySelector('span');
      const was = label.textContent;
      btn.classList.add('is-done'); label.textContent = 'Hinzugefügt';
      if (!reduce) gsap.fromTo(btn, { scale: 0.96 }, { scale: 1, duration: 0.6, ease: 'back.out(3)' });
      setTimeout(openCart, reduce ? 0 : 950);
      setTimeout(() => { btn.classList.remove('is-done'); label.textContent = was; }, 2200);
    }
    $('#pdAdd').addEventListener('click', e => buy(e.currentTarget));
    $('#pdBarAdd').addEventListener('click', e => buy(e.currentTarget));

    /* ---------- gallery ---------- */
    const track = $('#pdTrack'), n = G[id] || 0;
    const slides = [`<div class="pd__slide pd__slide--hero" style="--t:${p.tint}">
        <div class="pd__badge"><b>${esc(p.fact[0])}</b><span>${esc(p.fact[1])}</span></div>
        <i class="pd__plinth"></i>
        <img class="pd__hero" src="${cutout}" alt="${esc(p.full)}" width="800" height="800" fetchpriority="high" draggable="false">
      </div>`];
    for (let k = 0; k < n; k++) slides.push(`<div class="pd__slide" data-zoom>
        <img src="${img(`pdp/${id}-${k}-1080.webp`)}" srcset="${img(`pdp/${id}-${k}-600.webp`)} 600w, ${img(`pdp/${id}-${k}-1080.webp`)} 1080w"
             sizes="(max-width: 760px) 100vw, 50vw" width="1080" height="1080" alt="${esc(p.name)}, Bild ${k + 2}" loading="lazy" decoding="async" draggable="false">
      </div>`);
    track.innerHTML = slides.join('');
    tinted($('.pd__stage'));
    $('#pdAll').textContent = slides.length;
    $('#pdThumbs').innerHTML = slides.map((_, i) => `<button class="pd__thumb${i ? '' : ' pd__thumb--hero is-on'}" role="tab" aria-selected="${!i}" aria-label="Bild ${i + 1}" style="--t:${p.tint}">
        <img src="${i ? img(`pdp/${id}-${i - 1}-600.webp`) : prodImg(id)}" alt="" loading="lazy" decoding="async"></button>`).join('');
    $('#pdDots').innerHTML = slides.map((_, i) => `<i${i ? '' : ' class="is-on"'}></i>`).join('');
    const thumbs = $$('.pd__thumb'), dots = $$('#pdDots i');
    let cur = 0;
    const goTo = i => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
    function onSlide() {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === cur) return;
      $$('.pd__slide.is-zoom').forEach(s => s.classList.remove('is-zoom'));
      cur = i;
      $('#pdNow').textContent = i + 1;
      thumbs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i); });
      dots.forEach((t, k) => t.classList.toggle('is-on', k === i));
      $('#pdPrev').disabled = i === 0; $('#pdNext').disabled = i === slides.length - 1;
      thumbs[i]?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    }
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(onSlide); }, { passive: true });
    $('#pdPrev').addEventListener('click', () => goTo(cur - 1));
    $('#pdNext').addEventListener('click', () => goTo(cur + 1));
    $('#pdPrev').disabled = true;
    thumbs.forEach((t, k) => t.addEventListener('click', () => goTo(k)));
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') goTo(cur + 1); if (e.key === 'ArrowLeft') goTo(cur - 1); });

    if (fine) {
      // mouse: drag between images, click a photo to zoom and pan
      let down = null, moved = 0;
      track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button) return;
        down = { x: e.clientX, left: track.scrollLeft }; moved = 0;
        track.style.scrollSnapType = 'none';
      });
      addEventListener('pointermove', e => {
        if (!down) return;
        moved = Math.max(moved, Math.abs(e.clientX - down.x));
        if (moved > 4) track.scrollLeft = down.left - (e.clientX - down.x);
      });
      addEventListener('pointerup', e => {
        if (!down) return;
        const dx = e.clientX - down.x; down = null;
        track.style.scrollSnapType = '';
        if (moved > 4) goTo(cur + (dx < -60 ? 1 : dx > 60 ? -1 : 0));
      });
      track.addEventListener('click', e => {
        const sl = e.target.closest('[data-zoom]');
        if (!sl || moved > 4) return;
        sl.classList.toggle('is-zoom');
      });
      track.addEventListener('mousemove', e => {
        const sl = e.target.closest('.pd__slide.is-zoom'); if (!sl) return;
        const r = sl.getBoundingClientRect();
        sl.querySelector('img').style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`;
      });
      track.addEventListener('mouseleave', () => $$('.pd__slide.is-zoom').forEach(s => s.classList.remove('is-zoom')));
      // the bottle tilts towards the cursor
      if (!reduce) {
        const hero = $('.pd__hero');
        const rx = gsap.quickTo(hero, 'rotationY', { duration: 0.8, ease: 'power3' }), ry = gsap.quickTo(hero, 'rotationX', { duration: 0.8, ease: 'power3' });
        gsap.set(hero, { transformPerspective: 900 });
        $('.pd__stage').addEventListener('mousemove', e => {
          if (cur !== 0) return;
          const r = e.currentTarget.getBoundingClientRect();
          rx(((e.clientX - r.left) / r.width - 0.5) * 16); ry(-((e.clientY - r.top) / r.height - 0.5) * 10);
        });
        $('.pd__stage').addEventListener('mouseleave', () => { rx(0); ry(0); });
      }
    }

    /* ---------- story + stats ---------- */
    const [lead, ...more] = d.description.length ? d.description : [p.full];
    $('#pdLead').textContent = lead;
    if (more.length) $('#pdLead').insertAdjacentHTML('afterend', `<div class="pd-story__more">${more.map(t => `<p>${esc(t)}</p>`).join('')}</div>`);
    const stats = [];
    const numOf = t => { const m = String(t).match(/^(ca\.\s*)?(\d+(?:[.,]\d+)?)(\+?)\s*(.*)$/); return m ? { pre: m[1] || '', num: m[2], plus: m[3], rest: m[4] } : null; };
    // the card fact is split for narrow cards ("Mineral-" / "stoffe ..."): join it back here
    if (/-$/.test(p.fact[0])) { const [w, ...r] = p.fact[1].split(' '); stats.push({ big: p.fact[0].slice(0, -1) + w, label: r.join(' ') }); }
    else stats.push({ big: p.fact[0], label: p.fact[1] });
    let parts = (d.subtitle || '').split('|').map(t => t.trim()).filter(Boolean);
    if (!parts.length && d.bullets[0]) { // older template: read amounts from the first bullet
      const b0 = d.bullets[0];
      const amount = b0.match(/(\d+)\s+(Kapseln|Gummies|Portionen|Softgels)/), days = b0.match(/(\d+)\s+(Tage|Monate|Wochen)/);
      parts = [amount && amount[0], days && days[0]].filter(Boolean);
    }
    const UNIT = /^(g|mg|ml|kg)$/i;
    parts.forEach(t => {
      const m = numOf(t);
      if (!m || stats.some(s => numOf(s.big)?.num === m.num || `${s.big} ${s.label}`.includes(t))) return;
      const range = m.rest.match(/^bis\s+(\d+)\s*(.*)$/);
      if (range) stats.push({ big: `${m.num}–${range[1]}`, label: range[2] });
      else if (UNIT.test(m.rest)) stats.push({ big: `${m.num} ${m.rest}`, label: 'Inhalt' });
      else stats.push(m.rest ? { big: m.pre + m.num + m.plus, label: m.rest } : { big: t, label: '' });
    });
    const portions = parts.map(numOf).find(m => m && /Portion|Kapseln|Gummies/.test(m.rest));
    if (portions) stats.push({ big: euro(salePrice(p.price) / parseFloat(portions.num)), label: /Portion/.test(portions.rest) ? 'pro Portion' : 'pro ' + portions.rest.replace(/n$/, '').replace(/s$/, '') });
    $('#pdStats').innerHTML = stats.slice(0, 4).map(s => `<div class="pd-stat${s.big.length > 7 ? ' pd-stat--long' : ''}"><b data-num="${esc(s.big)}">${esc(s.big)}</b><span>${esc(s.label)}</span></div>`).join('');

    /* ---------- "Warum [Produkt]?" tiles ---------- */
    const IC = window.WAN_ICONS || {}, all = (window.WAN_BENEFITS || {})[id] || [];
    // the grid stays even: 6 tiles (3 x 2) or 4 tiles (one row), never 5
    const tiles = all.length >= 6 ? all.slice(0, 6) : all.slice(0, 4);
    if (tiles.length) {
      $('#pdWhyTitle').textContent = `Warum ${p.name}?`;
      const grid = $('#pdWhyGrid');
      grid.classList.toggle('pd-why__grid--4', tiles.length === 4);
      grid.innerHTML = tiles.map(([ic, t, txt]) => { const [line, acc] = IC[ic] || IC.leaf; return `<article class="why">
        <span class="why__icon"><svg class="benefit-icon" viewBox="0 0 48 48" aria-hidden="true"><path class="benefit-icon__line" d="${line}"/><path class="benefit-icon__accent" d="${acc}"/></svg></span>
        <h3>${esc(t)}</h3><p>${esc(txt)}</p></article>`; }).join('');
    } else $('#pdWhy').remove();

    /* ---------- ingredient spotlight ---------- */
    const ING_FALLBACK = []; // ids that should show the floating ingredient cutout instead of the photo
    let sp = d.spotlight || {};
    if (sp.title) {
      $('#pdSpotTag').textContent = sp.kicker || p.name;
      $('#pdSpotTitle').textContent = sp.title;
      $('#pdSpotText').innerHTML = (sp.text || []).map(t => `<p>${esc(t)}</p>`).join('');
      // every product now uses a generated image in the NAD+ style (tools/gen_spotlights.py); cutouts stay as fallback
      $('#pdSpotVisual').insertAdjacentHTML('beforeend', ING_FALLBACK.includes(id)
        ? `<img class="pd-spot__ing" src="${img(`pdp/${id}-ing-900.webp`)}" srcset="${img(`pdp/${id}-ing-520.webp`)} 520w, ${img(`pdp/${id}-ing-900.webp`)} 900w" sizes="(max-width: 760px) 80vw, 40vw" alt="${esc(sp.kicker || p.name)}" loading="lazy" decoding="async">`
        : `<div class="pd-spot__photo"><img src="${img(`pdp/${id}-spot-1200.webp`)}" srcset="${img(`pdp/${id}-spot-700.webp`)} 700w, ${img(`pdp/${id}-spot-1200.webp`)} 1200w" sizes="(max-width: 760px) 80vw, 40vw" alt="${esc(sp.kicker || p.name)}" loading="lazy" decoding="async"></div>`);
    } else $('#pdSpot').remove();

    /* ---------- details accordion ---------- */
    // split an ingredient list on commas that are not inside brackets
    const splitList = t => { const out = []; let depth = 0, buf = ''; for (const c of t) { if (c === '(') depth++; if (c === ')') depth--; if (c === ',' && !depth) { out.push(buf.trim()); buf = ''; } else buf += c; } out.push(buf.trim().replace(/\.$/, '')); return out.filter(Boolean); };
    const accItems = [...d.accordions];
    if (d.quality?.text?.length) accItems.push({ title: d.quality.title || 'Qualität & Herstellung', body: d.quality.text });
    $('#pdAcc').innerHTML = accItems.map((a, i) => {
      const isList = /Inhaltsstoffe|Zutaten/i.test(a.title) && a.body.length === 1 && splitList(a.body[0]).length > 2;
      const body = isList ? `<ul class="acc__chips">${splitList(a.body[0]).map(x => `<li>${esc(x)}</li>`).join('')}</ul>` : a.body.map(t => `<p>${esc(t)}</p>`).join('');
      return `<div class="acc__item${i ? '' : ' is-open'}">
        <h3><button class="acc__btn" aria-expanded="${!i}" aria-controls="acc${i}" id="accb${i}">${esc(a.title)}<i class="acc__icon" aria-hidden="true"></i></button></h3>
        <div class="acc__panel" id="acc${i}" role="region" aria-labelledby="accb${i}"${i ? '' : ' style="height:auto"'}><div class="acc__body">${body}</div></div></div>`;
    }).join('');
    $('#pdAcc').addEventListener('click', e => {
      const b = e.target.closest('.acc__btn'); if (!b) return;
      const item = b.closest('.acc__item'), panel = item.querySelector('.acc__panel'), open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
      if (reduce) { panel.style.height = open ? 'auto' : '0px'; return; }
      gsap.fromTo(panel, { height: panel.offsetHeight }, { height: open ? panel.scrollHeight : 0, duration: 0.6, ease: 'expo.out', onComplete: () => { if (open) panel.style.height = 'auto'; ScrollTrigger.refresh(); } });
      if (open) gsap.fromTo(panel.querySelector('.acc__body').children, { y: 14, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.04, duration: 0.6 });
    });
    const bottleBox = $('#pdDetailsBottle'); tinted(bottleBox);
    bottleBox.innerHTML = `<img src="${cutout}" alt="" loading="lazy" decoding="async">`;

    /* ---------- care, voices, related, philosophy ---------- */
    const CARE_ICONS = ['i-leaf', 'i-eu', 'i-flask', 'i-balance'];
    $('#pdCareTitle').textContent = S.careTitle || 'Darauf haben wir geachtet';
    $('#pdCareGrid').innerHTML = (S.care || []).map((c, i) => `<article class="care"><span class="care__icon"><svg aria-hidden="true"><use href="#${CARE_ICONS[i] || 'i-leaf'}"/></svg></span><h3>${esc(c.title)}</h3><p>${esc(c.text)}</p></article>`).join('');
    if (d.quotes?.length) {
      $('#pdVoicesGrid').innerHTML = d.quotes.map(q => `<blockquote class="vcard"><p>${esc(q.text)}</p><footer><i aria-hidden="true">${esc((q.name || 'K')[0])}</i>${esc(q.name || 'Kundin')}</footer></blockquote>`).join('');
    } else $('#pdVoices').remove();
    $('#pdRelTitle').textContent = S.relatedTitle || 'Weitere Produkte';
    initRail($('#pdRail'), P.filter(x => x.id !== id), { bar: $('#pdRailBar'), prev: $('#pdRailPrev'), next: $('#pdRailNext') });
    const ph = S.philosophy || {};
    $('#pdPhiloTitle').textContent = ph.title || '';
    $('#pdPhiloText').textContent = (ph.text || []).join(' ');

    /* ---------- sticky buy bar ---------- */
    const bar = $('#pdBar');
    tinted($('#pdBarImg'));
    $('#pdBarImg').innerHTML = `<img src="${cutout}" alt="">`;
    $('#pdBarName').textContent = p.name;
    if ('IntersectionObserver' in window) {
      let pastBuy = false, inFooter = false;
      const sync = () => { const on = pastBuy && !inFooter; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on); $('#pdBarAdd').tabIndex = on ? 0 : -1; };
      new IntersectionObserver(([e]) => { pastBuy = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe($('#pdBuy'));
      new IntersectionObserver(([e]) => { inFooter = e.isIntersecting; sync(); }, { rootMargin: '0px 0px -40% 0px' }).observe($('#footer'));
    }

    /* ---------- motion ---------- */
    if (reduce) { $$('.pd-story__lead .w').forEach(w => (w.style.opacity = 1)); return; }
    const intro = gsap.timeline({ delay: 0.05 });
    intro.fromTo('.pd__stage', { clipPath: 'inset(6% 6% 6% 6% round 40px)', scale: 0.97 }, { clipPath: 'inset(0% 0% 0% 0% round 0px)', scale: 1, duration: 1.4, ease: 'expo.out', clearProps: 'clipPath' }, 0)
      .fromTo('.pd__hero', { yPercent: 18, rotation: -6, opacity: 0 }, { yPercent: 0, rotation: 0, opacity: 1, duration: 1.6, ease: 'expo.out' }, 0.15)
      .fromTo('.pd__badge > *', { y: 20, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.08, duration: 1 }, 0.5)
      .fromTo('.pd__info > *, .pd__chips li', { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.06, duration: 1.1, ease: 'expo.out' }, 0.2)
      .fromTo('.pd__check path', { strokeDasharray: 24, strokeDashoffset: 24 }, { strokeDashoffset: 0, stagger: 0.08, duration: 0.6, ease: 'power2.out' }, 0.7)
      .fromTo('.pd__thumb', { y: 16, opacity: 0 }, { y: 0, opacity: (i, el) => (el.classList.contains('is-on') ? 1 : 0.6), stagger: 0.04, duration: 0.8, clearProps: 'opacity' }, 0.6);
    whenVisible($('.pd'), [gsap.to('.pd__plinth', { scaleX: 0.86, opacity: 0.75, duration: 3, ease: 'sine.inOut', yoyo: true, repeat: -1 })]);

    document.fonts.ready.then(() => {
      // description lights up word by word
      const words = splitWords($('#pdLead'));
      gsap.timeline({ scrollTrigger: { trigger: '#pdLead', start: 'top 80%', end: 'bottom 50%', scrub: 0.6 } })
        .to(words, { opacity: 1, stagger: 0.05, ease: 'none' });
      enter('.pd-story__more p', { y: 24, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.08 }, '.pd-story__more', 'top 85%');
      // section headings rise word by word
      $$('.pd-why .h2, .pd-spot .h2, .pd-details .h2, .pd-care .h2, .pd-voices .h2, .pd-related .h2, .pd-philo .h2').forEach(h => {
        const ws = prepLines(h);
        gsap.set(ws, { yPercent: 110 });
        ScrollTrigger.create({ trigger: h, start: 'top 85%', once: true, onEnter: () => gsap.to(ws, { yPercent: 0, stagger: 0.05, duration: 1.2 }) });
      });
      ScrollTrigger.refresh();
    });

    // numbers count up
    $$('.pd-stat b').forEach(b => {
      const m = b.dataset.num.match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m) return;
      const dec = (m[2].split(/[.,]/)[1] || '').length, target = parseFloat(m[2].replace(',', '.'));
      b.textContent = m[1] + (0).toFixed(dec).replace('.', ',') + m[3];
      ScrollTrigger.create({ trigger: b, start: 'top 90%', once: true, onEnter: () => {
        const o = { v: 0 };
        gsap.to(o, { v: target, duration: 1.8, ease: 'power2.out', onUpdate: () => (b.textContent = m[1] + o.v.toFixed(dec).replace('.', ',') + m[3]) });
      } });
    });
    enter('.pd-stat', { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.08, duration: 1.2 }, '.pd-stats', 'top 88%');

    // ingredient floats inside slowly turning orbits
    if ($('#pdSpot')) {
      const ing = $('.pd-spot__ing, .pd-spot__photo');
      whenVisible($('#pdSpot'), [
        gsap.to('.pd-spot__orbit i:nth-child(1)', { rotation: 360, duration: 60, ease: 'none', repeat: -1 }),
        gsap.to('.pd-spot__orbit i:nth-child(3)', { rotation: -360, duration: 90, ease: 'none', repeat: -1 }),
        gsap.to(ing, { y: -14, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1 })
      ]);
      gsap.fromTo(ing, { scale: 0.7, rotation: -12, opacity: 0 }, { scale: 1, rotation: 0, opacity: 1, ease: 'none', scrollTrigger: { trigger: '#pdSpot', start: 'top 85%', end: 'center 60%', scrub: 0.8 } });
      gsap.fromTo('.pd-spot__disc', { scale: 0.6, opacity: 0 }, { scale: 1, opacity: 1, ease: 'none', scrollTrigger: { trigger: '#pdSpot', start: 'top 85%', end: 'center 60%', scrub: 0.8 } });
      enter('.pd-spot__tag, .pd-spot__text p', { y: 24, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.08 }, '.pd-spot__copy', 'top 80%');
    }

    // details: bottle drifts while the accordion scrolls by
    gsap.fromTo('.pd-details__bottle img', { yPercent: 8, rotation: -3 }, { yPercent: -6, rotation: 3, ease: 'none', scrollTrigger: { trigger: '.pd-details', start: 'top bottom', end: 'bottom top', scrub: true } });
    enter('.acc__item', { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.07 }, '#pdAcc', 'top 85%');
    if ($('#pdWhy')) {
      enter('.why', { y: 50, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.08, duration: 1.2 }, '.pd-why__grid', 'top 85%');
      enter('.why__icon', { scale: 0.4, rotation: -20 }, { scale: 1, rotation: 0, stagger: 0.08, duration: 1.1, ease: 'back.out(2)' }, '.pd-why__grid', 'top 85%');
      enter('.why .benefit-icon__line', { strokeDasharray: 160, strokeDashoffset: 160 }, { strokeDashoffset: 0, stagger: 0.08, duration: 1.6, ease: 'power2.inOut', clearProps: 'strokeDasharray,strokeDashoffset' }, '.pd-why__grid', 'top 85%');
    }
    enter('.care', { y: 50, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.1, duration: 1.3 }, '.pd-care__grid', 'top 85%');
    enter('.care__icon', { scale: 0.4, rotation: -30 }, { scale: 1, rotation: 0, stagger: 0.1, duration: 1.2, ease: 'back.out(2)' }, '.pd-care__grid', 'top 85%');
    if ($('#pdVoices')) enter('.vcard', { y: 60, opacity: 0, rotation: i => (i % 2 ? 2 : -2) }, { y: 0, opacity: 1, rotation: 0, stagger: 0.1, duration: 1.3 }, '.pd-voices__grid', 'top 85%');
    gsap.fromTo('.pd-philo__media', { yPercent: -8, scale: 1.08 }, { yPercent: 8, scale: 1, ease: 'none', scrollTrigger: { trigger: '.pd-philo', start: 'top bottom', end: 'bottom top', scrub: true } });
    enter('.pd-philo__text', { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.1, duration: 1.3 }, '.pd-philo__copy', 'top 80%');
  }

  /* ---------- Marquees + loop ---------- */
  $$('[data-marquee]').forEach(marquee);
  if (!reduce) gsap.ticker.add((t, dt) => tickMarquees(dt / 1000));
  addEventListener('load', () => ScrollTrigger.refresh());
})();
